export default __webpack_public_path__ + "static/media/instruction4.3deecce7.png";